const SAFE_GRADE = { finalGrade: "-", progressPercent: null };

const flattenGradeItems = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.gradeitems)) return payload.gradeitems;
  if (Array.isArray(payload.usergrades)) {
    return payload.usergrades.flatMap((userGrade) => userGrade?.gradeitems || []);
  }
  return [];
};

const parsePercent = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "number" && Number.isFinite(value)) {
    return Math.max(0, Math.min(100, value));
  }

  const normalized = String(value).replace(/,/g, ".");
  const match = normalized.match(/(-?\d+(?:\.\d+)?)\s*%/);
  if (!match) return null;

  const parsed = Number(match[1]);
  return Number.isFinite(parsed) ? Math.max(0, Math.min(100, parsed)) : null;
};

const cleanGrade = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return String(value).replace(/\s*\([^)]*%[^)]*\)\s*/g, "").trim() || "-";
};

const isCourseTotal = (item) => String(item?.itemtype || "").toLowerCase() === "course";

const isGradableActivity = (item) => (
  String(item?.itemtype || "").toLowerCase() !== "course" &&
  String(item?.itemtype || "").toLowerCase() !== "category" &&
  String(item?.itemmodule || "").toLowerCase() !== "folder" &&
  item?.itemname !== null &&
  item?.itemname !== undefined &&
  item?.itemname !== ""
);

const hasVisibleGrade = (item) => (
  !item?.gradeishidden &&
  item?.graderaw !== null &&
  item?.graderaw !== undefined
);

export const extractCourseFinalGrade = (payload) => {
  const gradeItems = flattenGradeItems(payload);
  if (!gradeItems.length) return SAFE_GRADE;

  const activityItems = gradeItems.filter(isGradableActivity);
  const gradedItems = activityItems.filter(hasVisibleGrade);
  const courseTotal = gradeItems.find((item) => isCourseTotal(item) && !item?.gradeishidden);

  const finalGrade = cleanGrade(courseTotal?.gradeformatted || courseTotal?.graderaw || courseTotal?.grade);
  const progressPercent = activityItems.length
    ? (gradedItems.length * 100) / activityItems.length
    : parsePercent(courseTotal?.percentageformatted || courseTotal?.gradeformatted);

  return { finalGrade, progressPercent };
};

export default extractCourseFinalGrade;
